import { useState } from "react"
import { Container, Row, Col, Form, FloatingLabel } from "react-bootstrap";
import ModalPrivacidad from './ModalPrivacidad'
import contactImg from "../assets/img/robotcartero2.avif";
import buzon from "../assets/img/buzon.avif";
import cartero from "../assets/img/robot_cartero_movil.avif"
import './Contact.css'

export const Contact = () => {
    const formInitialDetails = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: '',
        privacy: false
    }

    const [showPrivacy, setShowPrivacy] = useState(false);
    const [formDetails, setFormDetails] = useState(formInitialDetails);
    const [buttonText, setButtonText] = useState('Enviar');
    const [status, setStatus] = useState({});
    const [validated, setValidated] = useState(false);

    const [errors, setErrors] = useState({
        firstName: '',
        email: '',
        phone: '',
        message: '',
        privacy: ''
    });

    const onFormUpdate = (category, value) => {
        setFormDetails({
            ...formDetails,
            [category]: value
        })
    }

    const validarCampo = (campo, valor) => {
        switch (campo) {
            case 'firstName':
                return valor.trim().length > 0 ? '' : 'El nombre no puede estar vacío';
            case 'email':
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor) ? '' : 'Email inválido';
            case 'message':
                return valor.trim().length >= 10 ? '' : 'El mensaje debe contener mínimo 10 caracteres';
            case 'privacy':
                return valor === true ? '' : 'Debes aceptar la Política de Privacidad';
            default:
                return '';
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        setStatus({});
        const newErrors = Object.keys(formDetails).reduce((acc, campo) => {
            if (campo === 'phone' && !formDetails.phone) {
                acc[campo] = '';
            } else {
                acc[campo] = validarCampo(campo, formDetails[campo]);
            }
            return acc;
        }, {});
        setErrors(newErrors);

        if (e.currentTarget.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            setStatus({ success: false, message: 'El correo no puede enviarse con campos erróneos' })
        } else {
            setButtonText('Enviando correo...');
            let response = await fetch("/api/contact", {
                method: "POST",
                headers: {
                    "Content-Type": "Application/json;charset=utf-8",
                },
                body: JSON.stringify(formDetails),
            });
            let result = await response.json();
            setButtonText("Enviar");
            setFormDetails(formInitialDetails);
            if (result.code === 200) {
                setStatus({ success: true, message: 'Correo enviado con éxito' })
            } else {
                setStatus({ success: false, message: 'Algo salió mal, por favor inténtalo de nuevo más tarde' })
            }
        }
    }

    return (
        <section className="contact" id="contact">
            <Container>
                <Col md={3}>
                    <img src={cartero} className="movil" alt="Contact me" />
                </Col>
                <Row className="align-items-center">
                    <Col md={3} className="mt-auto">
                        <img src={buzon} alt="Contact me" />
                    </Col>
                    <Col md={6} className="text-center">
                        <h2>Contacto</h2>
                        <Form noValidate validated={validated} onSubmit={handleSubmit} >
                            <Row className="g-1">
                                <Col sm={6} className="px-1">
                                    <FloatingLabel
                                        controlId="floatingInput"
                                        label="Nombre *"
                                        className="mb-3 form-floating-white">
                                        <Form.Control type="text" value={formDetails.firstName} placeholder=""
                                            onChange={(e) => onFormUpdate('firstName', e.target.value)}
                                            onBlur={(e) => {
                                                const error = validarCampo('firstName', e.target.value);
                                                setErrors(prev => ({ ...prev, firstName: error }));
                                            }}
                                            isInvalid={!!errors.firstName}
                                            isValid={!errors.firstName && formDetails.firstName.trim().length > 0}
                                            required />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.firstName}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                </Col>
                                <Col sm={6} className="px-1">
                                    <FloatingLabel
                                        controlId="floatingInput"
                                        label="Apellidos (opcional)"
                                        className="mb-3 form-floating-white">
                                        <Form.Control type="text" value={formDetails.lastName} placeholder=""
                                            onChange={(e) => onFormUpdate('lastName', e.target.value)} />
                                    </FloatingLabel>
                                </Col>
                                <Col sm={6} className="px-1">
                                    <FloatingLabel
                                        controlId="floatingInput"
                                        label="Correo *"
                                        className="mb-3 form-floating-white">
                                        <Form.Control type="email" value={formDetails.email} placeholder=""
                                            onChange={(e) => onFormUpdate('email', e.target.value)}
                                            onBlur={(e) => {
                                                const error = validarCampo('email', e.target.value);
                                                setErrors(prev => ({ ...prev, email: error }));
                                            }}
                                            isInvalid={!!errors.email}
                                            isValid={!errors.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formDetails.email)}
                                            required />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.email}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                </Col>
                                <Col sm={6} className="px-1">
                                    <FloatingLabel
                                        controlId="floatingInput"
                                        label="Teléfono (opcional)"
                                        className="mb-3 form-floating-white">
                                        <Form.Control type="tel" value={formDetails.phone} placeholder="" maxLength={9}
                                            onChange={(e) => { if (/^\d*$/.test(e.target.value)) { onFormUpdate('phone', e.target.value)}}}/>
                                    </FloatingLabel>
                                </Col>
                                <Col>
                                    <FloatingLabel
                                        controlId="floatingTextarea"
                                        label="Mensaje *"
                                        className="mb-3 form-floating-white">
                                        <Form.Control as="textarea" value={formDetails.message} placeholder=""
                                            onChange={(e) => onFormUpdate('message', e.target.value)}
                                            onBlur={(e) => {
                                                const error = validarCampo('message', e.target.value);
                                                setErrors(prev => ({ ...prev, message: error }));
                                            }}
                                            isInvalid={!!errors.message}
                                            isValid={!errors.message && formDetails.message.trim().length >= 10}
                                            required />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.message}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                    <div className="privacy-check-wrapper">
                                        <Form.Check
                                            type="checkbox"
                                            onChange={(e) => {
                                                onFormUpdate('privacy', e.target.checked);
                                                const error = validarCampo('privacy', e.target.checked);
                                                setErrors(prev => ({ ...prev, privacy: error }));
                                            }}
                                            label={
                                                <span >
                                                    He leído y acepto la <a onClick={() => setShowPrivacy(true)} className="legal-link">Política de Privacidad</a> *
                                                </span>
                                            }
                                            className="privacy-checkbox text-start"
                                            isInvalid={!!errors.privacy}
                                            required
                                        />
                                        {errors.privacy && (
                                            <div className={`privacy-error ${errors.privacy ? 'privacy-error--visible' : ''}`}>
                                                {errors.privacy}
                                            </div>
                                        )}
                                    </div>
                                    <button type="submit"><span>{buttonText}</span></button>

                                    <Row className="status-row-wrapper">
                                        <p className={
                                            !status.message ? "status-hidden" :
                                                status.success === true ? "success" : "danger"
                                        }>
                                            {status.message}
                                        </p>
                                    </Row>

                                </Col>
                            </Row>
                        </Form>
                    </Col>
                    <Col md={3} className="mt-auto">
                        <img src={contactImg} alt="Contact me" className="mt-n2 img-fluid" style={{ transform: 'translateY(-7%)' }} />
                    </Col>
                </Row>
                <Row>
                    <div className="alternativa-email">
                        <p className="texto-alternativo">
                            ¿Prefieres utilizar tu gestor de correo?
                            <span>&nbsp;&nbsp;</span>
                            <a className="enlace_correo"
                                href="mailto:penarrubia.92@gmail.com?subject=Contacto%20portfolio"
                                target="_blank" rel="noopener noreferrer"
                                style={{ color: '#0d6efd' }}>
                                clic aquí
                            </a>
                        </p>
                    </div>
                </Row>
            </Container>
            {showPrivacy && (
                <ModalPrivacidad showPrivacy={showPrivacy} onClose={() => setShowPrivacy(false)} />
            )}

        </section >
    )
}